// REDUX
import { useDispatch } from "react-redux";
import { updateCryptoStep } from "../../../../store/slices/cryptoSlice";

// COMPONENTS
import { ModalBody, ModalHeader } from "@nextui-org/react";
import { ButtonsFooter } from "../ButtonsFooter/ButtonsFooter";

// STYLES
import styles from "./FeedbackModal.module.scss";

// ASSETS
import CryptoImg from "../../../../assets/images/illustrations/crypto-mobile.svg?react";

interface Props {
  companyName: string;
}

const FeedbackModal = ({ companyName }: Props) => {
  const { header, flexContainer, description, headerContainer } = styles;
  const dispatch = useDispatch();

  return (
    <>
      <ModalHeader className={headerContainer}>
        <CryptoImg />
        <span className={header}>¿Ir a {companyName}?</span>
      </ModalHeader>

      <ModalBody className={`${flexContainer} py-[0px] px-[2rem]`}>
        <span className={description}>
          Vamos a redirigirte a {companyName}, ¿estás seguro que querés salir?
        </span>
      </ModalBody>

      <ButtonsFooter
        isMobile
        primaryButton={{
          text: `Ir a ${companyName}`,
          handleClick: () => dispatch(updateCryptoStep("REDIRECT")),
          isDisabled: false,
        }}
        secondaryButton={{
          text: "Volver",
          handleClick: () => dispatch(updateCryptoStep("ACCOUNTS")),
          isDisabled: false,
        }}
      />
    </>
  );
};
export default FeedbackModal;
